module.exports = __webpack_public_path__ + "static/media/zhariff-handout.4acd5032.pdf";